export const en = {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  'INDIVIDUAL-USER-MANAGEMENT': {
    TITLE: 'User Management',
    TABLE: {
      TITLE: 'Users',
      FILTERS: {
        SEARCH: 'Search',
        SEARCH_PLACEHOLDER: 'Search by name or role',
        COUNTRY: 'Country',
        STATE: 'State / Province',
        ENABLED: 'Active',
      },
      HEADER: {
        ID: 'ID',
        PHOTO: 'Avatar',
        NAME: 'Full name',
        BUSINESS_NAME: 'Job title',
        MAIN_TAG: 'Profession',
        AGE: 'Age',
        GENDER: 'Gender',
        EMAIL: 'Email',
        PHONE: 'Phone',
        CITY: 'City',
        STATE: 'State / Province',
        COUNTRY: 'Country',
        ENABLED: 'Status',
        CREATED_AT: 'Joined',
        LAST_LOGIN: 'Last active',
        DAYS_TO_FIRST_APPLY: 'Days to first application',
        TOTAL_APPLICATIONS: 'Total applications',
        SELECTED_APPLICATIONS: 'Shortlisted applications',
        ACTIONS: 'Actions',
      },
      TOOLTIP: { DELETE: 'Delete user' },
      NO_DATA: 'No users found.',
    },
    SUCCESS: {
      HEADER: 'Success',
      USER_UPDATED: 'User updated successfully.',
      USER_DELETED: 'User deleted successfully.',
    },
    DELETE_CONFIRMATION: {
      TITLE: 'Delete user',
      MESSAGE: 'Are you sure you want to delete {{name}}? This action cannot be undone.',
    },
    ERRORS: {
      GENERIC_ERROR: 'Something went wrong.',
      USER_UPDATE_FAILED: 'Failed to update user. Please try again.',
    },
  },
};

export default en;
